import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ValidationErrorComponent } from './validation-error/validation-error.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { BackofficeViewModeComponent } from './backoffice-view-mode/backoffice-view-mode.component';
import { CoreModule } from '@doc/core';
import { PageTitleComponent } from './page-title/page-title.component';
import { ListTableHeaderComponent } from './list-table-header/list-table-header.component';
import { CommonTitleComponent } from './common-title/common-title.component';
import { RouterModule } from '@angular/router';
import { DynamicIconComponent } from './dynamic-icon/dynamic-icon.component';
import { SafeHtmlPipe } from './safe-html.pipe';
import { DocNgbDialogComponent } from './ngb-dialog/doc-ngb-dialog.component';
import { DocTablePaginationComponent } from './table-pagination/doc-table-pagination.component';
import { DocNgbDatepickerComponent } from './ngb-datepicker/doc-ngb-datepicker.component';
import { DocNgbDateRangeComponent } from './ngb-datepicker/doc-ngb-date-range.component';
import { DocCustomRadioComponent } from './custom-radio/doc-custom-radio.component';
import { DocCustomToggleComponent } from './custom-toggle/doc-custom-toggle.component';
import { DocCustomCheckboxComponent } from './custom-checkbox/doc-custom-checkbox.component';
import { DocTimelineComponent } from './timeline/doc-timeline.component';
import { DocTimelineTemplateDirective } from './timeline/doc-timeline-template.directive';
import { DocDrawerComponent } from './drawer/doc-drawer.component';
import { DocDrawerTemplateDirective } from './drawer/doc-drawer-template.directive';
import { DocPopupMenuComponent } from './popup-menu/doc-popup-menu.component';
import { DocCarouselComponent } from './carousel/doc-carousel.component';
import { DocPaginatorComponent } from './paginator/doc-paginator.component';
import { DocChipsComponent } from './chips/doc-chips.component';
import { DocContextMenuComponent } from './context-menu/doc-context-menu.component';
import { DocPopoverComponent } from './popover/doc-popover.component';
import { DocTreeComponent } from './tree/doc-tree.component';
import { DocTreeNodeTemplateDirective } from './tree/doc-tree-node-template.directive';
import { DocGridViewCardComponent } from './grid-view-card/doc-grid-view-card.component';

import { NgSelectModule } from '@ng-select/ng-select';
@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    TranslateModule.forChild(),
    CoreModule,
    FormsModule,
    RouterModule,
    DocNgbDialogComponent,
    DocTablePaginationComponent,
    DocNgbDatepickerComponent,
    DocNgbDateRangeComponent,
    DocCustomRadioComponent,
    DocCustomToggleComponent,
    DocCustomCheckboxComponent,
    DocTimelineComponent,
    DocTimelineTemplateDirective,
    DocDrawerComponent,
    DocDrawerTemplateDirective,
    DocPopupMenuComponent,
    DocCarouselComponent,
    DocPaginatorComponent,
    DocChipsComponent,
    DocContextMenuComponent,
    DocPopoverComponent,
    DocTreeComponent,
    DocTreeNodeTemplateDirective,
    DocGridViewCardComponent,
    NgSelectModule],
  declarations: [
    ValidationErrorComponent,
    BackofficeViewModeComponent,
    PageTitleComponent,
    ListTableHeaderComponent,
    CommonTitleComponent,
    DynamicIconComponent,
    SafeHtmlPipe],
  exports: [
    ValidationErrorComponent,
    BackofficeViewModeComponent,
    PageTitleComponent,
    ListTableHeaderComponent,
    CommonTitleComponent,
    SafeHtmlPipe,
    DynamicIconComponent,
    DocNgbDialogComponent,
    DocTablePaginationComponent,
    DocNgbDatepickerComponent,
    DocNgbDateRangeComponent,
    DocCustomRadioComponent,
    DocCustomToggleComponent,
    DocCustomCheckboxComponent,
    DocTimelineComponent,
    DocTimelineTemplateDirective,
    DocDrawerComponent,
    DocDrawerTemplateDirective,
    DocPopupMenuComponent,
    DocCarouselComponent,
    DocPaginatorComponent,
    DocChipsComponent,
    DocContextMenuComponent,
    DocPopoverComponent,
    DocTreeComponent,
    DocTreeNodeTemplateDirective,
    DocGridViewCardComponent,
    NgSelectModule],
})
export class ComponentSharedModule {}
